<template>
  <v-app>
    <v-main class="blue-grey lighten-5">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  mounted() {
    const googleTagManagerScript = document.createElement('script');
    const googleTagManagerNoScript = document.createElement('noscript');
    googleTagManagerScript.async = true;
    googleTagManagerNoScript.async = true;
    googleTagManagerScript.defer = true;
    googleTagManagerNoScript.defer = true;
    googleTagManagerScript.type = 'text/javascript';
    googleTagManagerNoScript.type = 'text/javascript';
    if (process.env.VUE_APP_ENVIRONMENT === 'production') {
      googleTagManagerScript.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PQLMWZD');`;
      googleTagManagerNoScript.text = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PQLMWZD"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    } else {
      googleTagManagerScript.text = "console.log('GTM must be added :D')";
    }
    document.head.appendChild(googleTagManagerScript);
    document.body.appendChild(googleTagManagerNoScript);
  },
};
</script>
